import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import Panel from '../UI/Panel/Panel';
import ExtraBalanceManager from './ExtraBalanceManager/ExtraBalanceManager';
import AppContext from '../App/AppContext';

const ExtraBalance = ({ activator, showByDefault }) => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)',
  });

  const { setBalanceData } = useContext(AppContext);
  const [panelOverlay, setPanelOverlay] = useState(false);

  return (
    <Panel
      showClose
      title="Extra Saldo"
      isMobileDevice={isMobileDevice}
      activator={activator}
      closeCallback={() => setBalanceData(null)}
      showByDefault={showByDefault}
      panelOverlay={panelOverlay}
    >
      {({ setShow }) => (
        <ExtraBalanceManager
          setPanelOverlay={setPanelOverlay}
          closePanel={() => {
            setShow(false);
            setBalanceData(null);
          }}
        />
      )}
    </Panel>
  );
};

ExtraBalance.propTypes = {
  activator: PropTypes.func.isRequired,
  showByDefault: PropTypes.bool,
};

ExtraBalance.defaultProps = {
  showByDefault: false,
};

export default ExtraBalance;
